import $ from '../alias/jquery'

const ClassicBridge = {
    patchUser(userId, patch) {
        return window.ClassicBridge.patchUser(userId, patch)
    },

    getTasksForTaskList(params, settings) {
        return window.ClassicBridge.getTasksForTaskList(params, settings)
    },

    getTasksForTaskListSynced(params, settings) {
        return ClassicBridge.syncChangesFromClassic()
            .then(() => window.ClassicBridge.getTasksForTaskList(params, settings))
    },

    getTasksSummary(params) {
        return window.ClassicBridge.getTasksSummary(params)
    },

    getLeaveTypes() {
        return window.ClassicBridge.getLeaveTypes()
    },

    getKanbanSummary(params) {
        return ClassicBridge.syncChangesFromClassic()
                            .then(() => window.ClassicBridge.getKanbanSummary(params))
    },

    getUsersByClassicIds(ids) {
        return window.ClassicBridge.getUsersByClassicIds(ids)
    },

    getDefaultWorkStatusPlanningByUserId(id) {
        return window.ClassicBridge.getDefaultWorkStatusPlanningByUserId(id)
    },

    putUserDefaultWorkStatuses(id, patch) {
        return window.ClassicBridge.putUserDefaultWorkStatuses(id, patch)
    },

    getWorkStatusesForUserProfile() {
        return window.ClassicBridge.getWorkStatusesForUserProfile()
    },

    canImportTimeTrack() {
        return window.ClassicBridge.canImportTimeTrack()
    },

    getTaskCustomFieldsList() {
        return window.ClassicBridge.getTaskCustomFieldsList()
    },

    isCustomField(key) {
        return window.ClassicBridge.isCustomField(key)
    },

    getWorkflowStatusesList() {
        return window.ClassicBridge.getWorkflowStatusesList()
    },

    patchTaskCustomField(id, fieldName, value) {
        return window.ClassicBridge.patchTaskCustomField(id, fieldName, value)
    },

    patchTask(id, patch) {
        return window.ClassicBridge.patchTask(id, patch)
    },

    /**
     * Returns object with setProps method
     * @param el
     * @returns {*}
     */
    integrateTaskPanelDetails(el) {
        return window.ClassicBridge.integrateTaskPanelDetails(el)
    },

    integrateBudgetsTab(el, props) {
        return window.ClassicBridge.integrateBudgetsTab(el, props)
    },

    integrateCalendar(el, props) {
        return window.ClassicBridge.integrateCalendar(el, props)
    },

    integrateFromDateSelector(el, props) {
        return window.ClassicBridge.integrateFromDateSelector(el, props)
    },

    getNextBiweeklyAccrualDateFromDate(today, fromDate, dateFormat) {
        return window.ClassicBridge.getNextBiweeklyAccrualDateFromDate(today, fromDate, dateFormat)
    },

    getShortNextBiweeklyAccrualDateFromDate(today, fromDate, dateFormat) {
        return window.ClassicBridge.getShortNextBiweeklyAccrualDateFromDate(today, fromDate, dateFormat)
    },

    getNextFridayDate(today) {
        return window.ClassicBridge.getNextFridayDate(today)
    },

    getDateWeekday(date) {
        return window.ClassicBridge.getDateWeekday(date)
    },

    integrateTaskListFiltersPanel(el, props) {
        return window.ClassicBridge.integrateTaskListFiltersPanel(el, props)
    },

    integrateTaskListColumnConfigurator(el, props) {
        return window.ClassicBridge.integrateTaskListColumnConfigurator(el, props)
    },


    integrateAddFilters(el, props) {
        return window.ClassicBridge.integrateAddFilters(el, props)
    },

    integrateInputWithSuggestions(el, props, fieldId) {
        return window.ClassicBridge.integrateInputWithSuggestions(el, props, fieldId)
    },

    integrateDefaultWorkStatusPlanning(el, props) {
        return window.ClassicBridge.integrateDefaultWorkStatusPlanning(el, props)
    },

    integrateDefaultWorkdayStartEnd(el, props) {
        return window.ClassicBridge.integrateDefaultWorkdayStartEnd(el, props)
    },

    integrateTooltipDefaultWorkStatusPlanning(el, props) {
        return window.ClassicBridge.integrateTooltipDefaultWorkStatusPlanning(el, props)
    },


    integrateInitialDefaultWorkStatus(el, props) {
        return window.ClassicBridge.integrateInitialDefaultWorkStatus(el, props)
    },

    integrateExportCPDropdown(el, props) {
        return window.ClassicBridge.integrateExportCPDropdown(el, props)
    },

    integrateExportUsersDropdown(el, props) {
        return window.ClassicBridge.integrateExportUsersDropdown(el, props)
    },

    integrateDeadlineSelector(el, props) {
        return window.ClassicBridge.integrateDeadlineSelector(el, props)
    },

    integrateCFDropdownSelector(el, props) {
        return window.ClassicBridge.integrateCFDropdownSelector(el, props)
    },

    integrateCsvUserImportModal(el) {
        return window.ClassicBridge.integrateCsvUserImportModal(el)
    },

    integrateWorkSchedulingTable(el, mode) {
        return window.ClassicBridge.integrateWorkSchedulingTable(el, mode)
    },

    integrateWorkStatusesReport(el) {
        return window.ClassicBridge.integrateWorkStatusesReport(el)
    },

    integrateUserFilter(el, props) {
        return window.ClassicBridge.integrateUserFilter(el, props)
    },

    integrateProgressBar(el, props) {
        return window.ClassicBridge.integrateProgressBar(el, props)
    },

    integrateFullscreenSpinner(el, props) {
        return window.ClassicBridge.integrateFullscreenSpinner(el, props)
    },

    integrateSpinner(el, props) {
        return window.ClassicBridge.integrateSpinner(el, props)
    },

    /**
     * !!Usage note
     * Because of the existent implementation, doesn't work without 'special' container
     * You may use a code like this:
     *  ```
     *  $('<div/>').addClass('atNextMount atNextOverlays').appendTo($('body'))
     *  ```
     */
    integrateProgressFullscreenSpinner(el, props) {
        return window.ClassicBridge.integrateProgressFullscreenSpinner(el, props)
    },

    integrateAddTaskToTimesheetButton(el, props) {
        return window.ClassicBridge.integrateAddTaskToTimesheetButton(el, props)
    },

    integrateMarkAsLeaveBlackoutConfirmation(el, props) {
        return window.ClassicBridge.integrateMarkAsLeaveBlackoutConfirmation(el, props)
    },

    integrateLeaveBlackoutLegendDropdown(el, props) {
        return window.ClassicBridge.integrateLeaveBlackoutLegendDropdown(el, props)
    },

    findCurrentInterval(today, intervals) {
        return window.ClassicBridge.findCurrentInterval(today, intervals)
    },

    /**
     * Waiting while actual data will by synced from classic. For example, waiting after task creation
     * @returns {*}
     */
    syncChangesFromClassic() {
        return window.ClassicBridge.syncChangesFromClassic()
    },

    getTasksAfterModification(classicTaskIds) {
        return new Promise((res) => {
            window.ClassicBridge.syncChangesFromClassic().then(() => {
                window.ClassicBridge.getTasksForTaskList({ taskIds: classicTaskIds }).then((nextData) => {
                        if (nextData.items.length !== 0) {
                            return res(nextData.items)
                        }

                        return res(null)
                    })
                }).catch(() => res(null))
            })
    },

    convertTimeToFormat(value, allowZero, outFormat) {
        return window.ClassicBridge.convertTimeToFormat(value, allowZero, outFormat)
    },

    sendUserEvent(event, params = {}, async = true) {
        return window.ClassicBridge.sendUserEvent(event, params, async)
    },

    getImportTasksFromCsvRequestUrl() {
        return window.ClassicBridge.getImportTasksFromCsvRequestUrl()
    },

    postImportTasksRequest(table, index, totalRows, operationId) {
        return window.ClassicBridge.postImportTasksRequest(table, index, totalRows, operationId)
    },

    showSuccessToast(message) {
        return window.ClassicBridge.showSuccessToast(message)
    },

    getLeaveBlackoutDays(year) {
        return window.ClassicBridge.getLeaveBlackoutDays(year)
    },

    addLeaveBlackoutDay(date) {
        return window.ClassicBridge.addLeaveBlackoutDay(date)
    },

    getNonApprovedLeaveRequestsForDay(date) {
        return window.ClassicBridge.getNonApprovedLeaveRequestsForDay(date)
    },

    deleteLeaveBlackoutDay(date) {
        return window.ClassicBridge.deleteLeaveBlackoutDay(date)
    },

    setLeaveBlackoutPresetStyles(color) {
        window.ClassicBridge.setLeaveBlackoutPresetStyles(color)
    },

    integrateHistogram(el, props) {
        return window.ClassicBridge.integrateHistogram(el, props)
    },
}

/**
 *
 * @param taskId
 * @param retryIfNoData - retry request while data will not available or attempts will end
 * Usually chains of request performed:
 * -> POST to classic data modifications
 * -> /sync-data-from-classic - waiting while data was synced {@see ClassicBridge#syncChangesFromClassic}
 * -> GET data from next
 * But sometimes due https://jira.actimind.com/browse/AT-7569 data is not synced after `sync-data-from-classic`
 * Retry reading allow to retrieve data with small delay
 * @returns {Promise<unknown>}
 */
ClassicBridge.getTask = (taskId, retryIfNoData = false) => {
    const timesToRepeat = retryIfNoData ? 10 : 1
    let nRepeats = 0
    const msBetweenRepeat = 500
    const recCall = (resolve, reject) => {
        ClassicBridge.getTasksForTaskList({ taskIds: [taskId] }).then((result) => {
            const task = result.items[0]
            if (task) {
                resolve(task)
            } else {
                if (++nRepeats >= timesToRepeat) {
                    reject(`task not fetching in ${timesToRepeat} repeats`)
                } else {
                    setTimeout(() => recCall(resolve, reject), msBetweenRepeat)
                }
            }
        })
    }
    return new Promise(recCall)
}

ClassicBridge.onDemoDataJustLoaded = () => {
    $(document).trigger('demo_data_just_loaded')
}

export default ClassicBridge



// WEBPACK FOOTER //
// ./web/js/next/ClassicBridge.js